<template>
  <div>
    <status-indicator :status="bookingStatus" class="mr"/>
    <small>
      {{ currentStatus }}
      <template v-if="rejectedBy">
        by {{ rejectedBy.name }}
      </template>
    </small>
  </div>
</template>

<script>
export default {

  props: {
    currentStatus: String,
    rejectedBy: {
      type: Object|Boolean,
      default: false
    }
  },

  computed: {
    bookingStatus() {
      let map = {
        'Pending Approval': '',
        'Approved': 'active',
        'Rejected': 'negative',
        'Pending Payment': 'intermediary',
        'Payment Received': 'positive',
      }
      return map[this.currentStatus]
    }
  }

}
</script>
